import styled from "styled-components";
import { Icon } from "~components/common/Icon";
import cn from "classnames";

const HoverIcon = styled(Icon).attrs((p) => ({
  borderRadius: "sm",
  p: "1/2",
  className: cn("hover-child", p.className),
}))`
  cursor: pointer;
  transition: all 0.12s ease-out;

  &:active,
  &.active {
    transition-duration: 0;
    background-color: ${(p) => p.theme.colors.N200};
  }

  // Prevents hover while in active state.
  &:not(:active, .active):hover {
    background-color: ${(p) => p.theme.colors.N100};
  }
`;

export default HoverIcon;
